
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'LoaderSvg' })
export default class LoaderSvg extends Vue {}
